import { Component, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare var $: any; // so we can use jQuery

@Component({
  selector: 'app-digital-stamp-card',
  templateUrl: './digital-stamp-card.component.html'
})
export class DigitalStampCardComponent implements AfterViewInit {

  constructor(private translate: TranslateService) {}

  ngAfterViewInit(): void {
    // jQuery toggle for digital stamp card button
    $('.btn-digital-stamp-card').on('click', function () {
      $(this).parent().toggleClass("open");
      $(this).parent().next().slideToggle("fast");
    });
  }

  onLanguageSwitched(event: Event) {
    let currentLang = this.translate.currentLang || 'en';
    let lang = this.translate.getLangs().find(l => l !== currentLang) || 'en';

    document.getElementById('preloader')?.classList.remove('hide');
    this.translate.use(lang).subscribe(() => {
      location.reload();
    });
    event.preventDefault();
  }
}
